// AI Visibility platforms
export const AI_VISIBILITY_PLATFORMS = {
  GOOGLE_AI_OVERVIEW: 'google_ai_overview',
  GOOGLE_AI_MODE: 'google_ai_mode',
  CHATGPT: 'chatgpt'
} as const;

// The full platform list in declaration order, for consumers that iterate or submit all of them
export const AI_VISIBILITY_PLATFORM_VALUES = Object.values(AI_VISIBILITY_PLATFORMS);

// AI Visibility report run statuses
export const AI_VISIBILITY_RUN_STATUS = {
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
} as const;

// Comparison outcome of a single platform between two compared AI Visibility runs
export const AI_VISIBILITY_PLATFORM_COMPARISON_STATUS = {
  COMPARED: 'compared',
  NEW: 'new',
  MISSING: 'missing'
} as const;

// AI Visibility report schedule frequencies
export const AI_VISIBILITY_SCHEDULE_FREQUENCY = {
  MANUAL: 'manual',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly'
} as const;

// 3-hour schedule slot start times (HH:MM:SS) the AI Visibility API accepts
export const AI_VISIBILITY_SCHEDULE_TIME_SLOTS = [
  '00:00:00',
  '03:00:00',
  '06:00:00',
  '09:00:00',
  '12:00:00',
  '15:00:00',
  '18:00:00',
  '21:00:00'
] as const;

// Days of the month a monthly AI Visibility schedule runs on, capped at 28 so every month has them
export const AI_VISIBILITY_SCHEDULE_MONTH_DAYS = Object.freeze(Array.from({ length: 28 }, (_, index) => index + 1));
